import Vue from "vue";

let currantData = new Vue({
    data: {
        $baseUrl: process.env.VUE_APP_BASE_URL,
        $successMessage: '',
        $errorMessage: '',
        $warningMessage: '',
    },
});
Vue.mixin({
    computed: {
        $baseUrl: {
            get: function () {
                return currantData.$data.$baseUrl
            },
            set: function (data) {
                currantData.$data.$baseUrl = data;
            }
        },
        $successMessage: {
            get: function () {
                return currantData.$data.$successMessage
            },
            set: function (data) {
                currantData.$data.$successMessage = data;
            }
        },
        $errorMessage: {
            get: function () {
                return currantData.$data.$errorMessage
            },
            set: function (data) {
                currantData.$data.$errorMessage = data;
            }
        },
        $warningMessage: {
            get: function () {
                return currantData.$data.$warningMessage
            },
            set: function (data) {
                currantData.$data.$warningMessage = data;
            }
        },
    }
});